import { conversationSearchFacets } from "./conversationSearchFacets";
import { conversationThreadPin } from "./conversationThreadPin";
import { assistantMessageFields } from "./assistantMessageFields";

function createdAtMs(value) {
  const parsed = Date.parse(String(value ?? ""));
  return Number.isFinite(parsed) ? parsed : Date.now();
}

export function conversationToThread(row = {}) {
  return {
    id: String(row.id ?? ""),
    title: String(row.title || "New chat"),
    workspaceId: row.workspace_id ?? row.workspaceId ?? null,
    projectId: row.project_id ?? null,
    model: row.model ?? null,
    updatedAt: row.updated_at ?? row.created_at ?? null,
    ...conversationThreadPin(row),
    ...conversationSearchFacets(row),
  };
}

export function messageToChatMessage(row = {}) {
  const metadata =
    row.metadata && typeof row.metadata === "object" ? row.metadata : {};
  const isAssistant = row.role === "assistant";
  const id = String(
    row.id ?? `${row.role ?? "message"}-${row.created_at ?? Date.now()}`,
  );
  return {
    id,
    ...(isAssistant ? assistantMessageFields(metadata, id) : {}),
    role: isAssistant ? "assistant" : "user",
    text: String(row.content ?? ""),
    createdAt: createdAtMs(row.created_at),
    ...(Array.isArray(row.citations) ? { citations: row.citations } : {}),
    ...(Array.isArray(metadata.attachments)
      ? { files: metadata.attachments }
      : {}),
    ...(row.run_id ? { phase1RunId: String(row.run_id) } : {}),
    ...(isAssistant && row.run_id ? { phase1MessageId: id } : {}),
    ...(isAssistant ? { phase1: true } : {}),
  };
}

export function conversationToMessages(row = {}) {
  return (Array.isArray(row.messages) ? row.messages : []).map(
    messageToChatMessage,
  );
}
